var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice365(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m78.7 34.2h49.3v29.8h-49.3z",
    fill: "#21a365"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m78.7 64h49.3v29.8h-49.3z",
    fill: "#107c41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.5 34.2h49.2v29.8h-49.2z",
    fill: "#107c41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m78.7 93.8v-29.8h-49.1v29.8 4.3 19.6c0 3.2 2.6 5.8 5.8 5.8h86.7c3.2 0 5.8-2.6 5.8-5.8v-23.9z",
    fill: "#185b37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m122.1 4.5h-43.5v29.8h49.4v-24c-.1-3.2-2.7-5.8-5.9-5.8z",
    fill: "#33c481"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m78.7 4.5h-43.2c-3.2 0-5.8 2.6-5.8 5.8v23.9h49.1v-29.7z",
    fill: "#21a365"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m59.5 96.5h-53c-3.5 0-6.4-2.9-6.4-6.4v-52.2c0-3.5 2.9-6.4 6.4-6.4h53c3.5 0 6.4 2.9 6.4 6.4v52.2c0 3.5-2.8 6.4-6.4 6.4z",
    fill: "#17864c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.5 82.4-3.9-7.1c-1.6-2.8-2.6-4.7-3.7-6.8h-.1c-.9 2.1-1.8 4-3.3 6.8l-3.5 7.1h-7.6l10.8-18.1-10.5-17.8h7.7l3.9 7.4c1.2 2.2 2.1 4 3 6h.2c1-2.2 1.7-3.8 2.9-6l3.9-7.4h7.6l-10.7 17.5 11.1 18.4z",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m66.7 37.3v.6 52.2c0 3.5-2.9 6.4-6.4 6.4h-29.9v5.7h35.2c3.5 0 6.4-2.9 6.4-6.4v-52.2c.1-3.2-2.3-5.9-5.3-6.3z",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice365);
export default __webpack_public_path__ + "static/media/office365.bee65204a7b2a8c02f8cad8aa5373bb3.svg";
export { ForwardRef as ReactComponent };